import { mountApp } from '@/apps/mount_app';
import HackathonRecommendations from '@/components/devpost_homepage/HackathonRecommendations.vue'

export default () => {
  mountApp({
    domId: "hackathon-recommendations",
    component: HackathonRecommendations
  })
}
